<template>
  <div class="">
    <Head title="Editar Oferta de Trabajo"></Head>
    <div class="container-fluid px-0">
      <div class="lpg-header position-relative">
        <img src="/images/lpg-rect-4.png" class="img-fluid vw-100" alt="..." />
        <h1 class="position-absolute">Editar Oferta de Trabajo</h1>
      </div>
    </div>
    <div class="container-fluid py-5">
      <div class="row">
        <div class="col-12 col-md-10 col-lg-6 mx-auto">
          <div class="lpg-form px-3">
            <h2 class="lpg-form-title">Información general de la oferta de trabajo</h2>
            <text-input
              id="title"
              v-model="form.title"
              label="Título de la oferta de trabajo"
              :required="true"
            ></text-input>
            <text-input
              id="offered_position"
              v-model="form.offered_position"
              label="Cargo"              
              :required="true"
            ></text-input>
            <text-input
               id="vacancies"
               v-model="form.vacancies"
              label="Plazas de oferta de trabajo"             
              type="number"
              min="1"
              :required="true"       
            ></text-input>
             <check-input
              id="salary_to_be_agreed"
              v-model="form.salary_to_be_agreed"
              label="Salario a convenir"
              :required="false"
            ></check-input>
            <div v-if="form.salary_to_be_agreed == false">
              <text-input
                id="salary_min"
                v-model="form.salary_min"
                label="Salario mínimo de la oferta de trabajo"              
                type="number"
                min="0"
                :required="true"
                :placeholder="form.salary_min"
              ></text-input>
                <text-input
                label="Salario máximo de la oferta de trabajo"
                id="salary_max"
                v-model="form.salary_max"
                type="number"
                min="0"
                :required="true"
                :placeholder="form.salary_max"         
              ></text-input>
            </div> 
            <select-input
              v-model="form.job_category_id"
              label="Categorìa de la oferta de trabajo"
              id="job_category"
              :required="true"
            >
              <option value="" disabled>Seleccionar</option>
              <option v-for="category in job_categories" :key="category.id" :value="category.id">
                {{ category.name }}
              </option>
            </select-input>
            
            <select-input
              v-model="form.contract_type_id"
              label="Tipo de contrato"
              id="education_level"
              :required="true"
            >
              <option value="" disabled>Seleccionar</option>
              <option v-for="contract in contract_types" :key="contract.id" :value="contract.id">
                {{ contract.name }}
              </option>
            </select-input>
            <select-input
              v-model="form.education_level_id"
              label="Nivel de educaciòn para aplicar"
              id="education_level"
              :required="true"
            >
              <option value="" disabled>Seleccionar</option>
              <option v-for="education in education_levels" :key="education.id" :value="education.id">
                {{ education.name }}
              </option>
            </select-input>

            <h2 class="lpg-form-title">Descripción de la oferta de trabajo</h2>

            <textarea-input
              id="short_description"
              v-model="form.short_description"
              label="Descripción corta de la oferta de trabajo"
              name="short_description"
              :required="false"
              :maxlength="300"
            ></textarea-input>
            <textarea-input
              id="full_description"
              v-model="form.full_description"
              label="Descripción completa de la oferta de trabajo"
              name="full_description"
              :required="false"
              :maxlength="2000"
            ></textarea-input>
            <textarea-input
              id="required_qualifications"
              v-model="form.required_qualifications"
              label="Requisitos de la oferta de trabajo"
              name="required_qualifications"
              :required="false"
              :maxlength="500"
            ></textarea-input>
            <textarea-input
              id="job_responsibilities"
              v-model="form.job_responsibilities"
              label="Responsabilidades de la oferta de trabajo"
              name="job_responsibilities"
              :required="false"
              :maxlength="500"
            > </textarea-input>
            <textarea-input
              id="benefits_and_perks"
              v-model="form.benefits_and_perks"
              label="Beneficios ofrecidos al aplicante"
              name="benefits_and_perks"
              :required="false"
              :maxlength="500"
            > </textarea-input>
            <button type="submit" @click.prevent="updatejobposting" class="btn btn-secondary mx-auto d-block mt-5">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import LayoutEmpresas from '@/Layouts/LayoutEmpresas.vue'
import TextInput from '@/Components/Form/TextInput.vue'
import SelectInput from '@/Components/Form/SelectInput.vue'
import TextareaInput from '@/Components/Form/TextareaInput.vue'
import CheckInput from '@/Components/Form/CheckInput.vue'

export default {
  name: 'CompanyJobPostingEdit',
  layout: LayoutEmpresas,
  components: {
    Head,
    TextInput,
    SelectInput,
    TextareaInput,
    CheckInput,
  },
  props: {
    jobposting:Object,
    job_categories: Array,
    education_levels: Array,
    contract_types: Array,
  },
  data() {
    return {
      form: {
        id :this.jobposting.id,
        title: this.jobposting.title,
        offered_position: this.jobposting.offered_position,
        short_description: this.jobposting.short_description,
        salary_min: this.jobposting.salary_min,
        salary_max: this.jobposting.salary_max,
        full_description: this.jobposting.full_description,
        required_qualifications: this.jobposting.required_qualifications,
        job_responsibilities: this.jobposting.job_responsibilities,
        benefits_and_perks: this.jobposting.benefits_and_perks,
        provides_law_benefits: this.jobposting.provides_law_benefits,
        vacancies: this.jobposting.vacancies, 
        job_category_id: this.jobposting.job_category_id,
        education_level_id: this.jobposting.education_level_id,
        contract_type_id: this.jobposting.job_contract_type_id,
        salary_to_be_agreed: this.jobposting.salary_to_be_agreed,   
      },
    } 
    
  },
  methods: {
    updatejobposting() {
      this.$inertia.put(this.$route('company.ofertas.update'), this.form)
    },
  },
}
</script>
